import React from "react";
import Graph from "@/components/Graph";
import PageBreathingAura from "@/components/PageBreathingAura";

export const InsightsTab = () => {
  return (
    <div
      data-testid="insights-tab"
      className="flex h-full min-h-0 flex-col gap-5 overflow-y-auto px-4 pt-10 pb-24 relative z-10"
      style={{
        animation: "fadeIn 0.4s ease-out",
        overscrollBehavior: "contain",
        WebkitOverflowScrolling: "touch",
        background: "linear-gradient(180deg, rgba(17,12,8,0.72) 0%, rgba(10,9,8,0.44) 44%, rgba(56,40,22,0.28) 100%)",
      }}
    >
      <PageBreathingAura variant="insights" />

      <div className="relative z-10" style={{ animation: "fadeInUp 0.45s ease-out" }}>
        <p className="text-[11px] uppercase tracking-[0.32em] text-[#8A755A]">Main Insight</p>
        <h1 className="mt-3 max-w-[16rem] text-[2.15rem] font-light leading-[1.08] tracking-tight text-[#F3E5D2]">
          Your Week With [FRQNCY.]
        </h1>
      </div>

      <div className="relative z-10" style={{ animation: "fadeInUp 0.58s ease-out" }}>
        <Graph />
      </div>
    </div>
  );
};

export default InsightsTab;
